export default {
    '@': [
        {
            icon: 'at',
            picker: '@Rebilly (this will contact Rebilly support)',
            value: '@Rebilly',
        },
    ],
};
